namespace Matrix.Data {
    export interface AssignNewSecurityIdRequest extends Serenity.ServiceRequest {
        RowId?: number;
    }
}
